import { Box, Icon, IconButton, InputChip, Menu } from '@zillow/constellation-10';
import { IconFilterFilled } from '@zillow/constellation-icons';

type Props = {
  isArchived: boolean;
  onArchivedChange: (isArchived: boolean) => void;
  isLoading?: boolean;
};

export const FiltersMenu = ({ isArchived, onArchivedChange, isLoading = false }: Props) => (
  <Menu.Root placement="bottom-start">
    <Menu.Trigger>
      <IconButton
        aria-label="Filters"
        title="Filters"
        tone="neutral"
        emphasis="bare"
        size="sm"
        disabled={isLoading}
        data-testid="FlexiblePropertiesPage-Toolbar-FiltersTrigger"
      >
        <Icon render={<IconFilterFilled />} />
      </IconButton>
    </Menu.Trigger>
    <Menu.Portal>
      <Menu.Content>
        <Menu.Item
          role="menuitemcheckbox"
          aria-checked={isArchived}
          disabled={isLoading}
          onClick={() => onArchivedChange(!isArchived)}
          data-testid="FlexiblePropertiesPage-Toolbar-ArchivedToggle"
        >
          <Menu.ItemLabel>Archived</Menu.ItemLabel>
        </Menu.Item>
      </Menu.Content>
    </Menu.Portal>
  </Menu.Root>
);

export const ActiveFilters = ({ isArchived, onArchivedChange, isLoading = false }: Props) => (
  <Box css={{ display: 'flex', alignItems: 'center', gap: '200' }}>
    <InputChip
      isOpen={isArchived}
      onClose={() => onArchivedChange(false)}
      disabled={isLoading}
      data-testid="FlexiblePropertiesPage-Toolbar-ArchivedChip"
    >
      Archived
    </InputChip>
  </Box>
);
